// Catalogue de schémas d'écritures comptables types — Cabinet KEYTO
// Modèles classiques classés par cycle, avec écriture complète et commentaire.

export const ECRITURES = [
  // ─── ACHATS ──────────────────────────────────────────────────────────
  {
    id: "achat-marchandises-tva20",
    cycle: "Achats",
    titre: "Achat de marchandises avec TVA 20 %",
    situation: "Achat de marchandises pour 1 000 € HT, TVA 20 % (200 €), total 1 200 € TTC.",
    lignes: [
      { num: "607", lib: "Achats de marchandises", debit: 1000, credit: 0 },
      { num: "44566", lib: "TVA déductible sur ABS", debit: 200, credit: 0 },
      { num: "401", lib: "Fournisseurs", debit: 0, credit: 1200 },
    ],
    commentaire:
      "Le HT alimente la charge (classe 6), la TVA est une créance sur l'État (44566), le TTC devient une dette envers le fournisseur (401).",
    variantes: ["TVA 10 % → 44566 calculée à 10 %", "TVA 5,5 % (livres, alimentaire) idem"],
  },
  {
    id: "avoir-fournisseur",
    cycle: "Achats",
    titre: "Avoir reçu d'un fournisseur",
    situation: "Le fournisseur émet un avoir de 240 € TTC pour retour de marchandises (200 HT + 40 TVA).",
    lignes: [
      { num: "401", lib: "Fournisseurs", debit: 240, credit: 0 },
      { num: "609", lib: "RRR obtenus sur achats", debit: 0, credit: 200 },
      { num: "44566", lib: "TVA déductible", debit: 0, credit: 40 },
    ],
    commentaire:
      "L'avoir diminue la dette (401 débité). On contrepasse la TVA et on enregistre la réduction en 609 (sens créditeur car réduit la charge).",
  },
  {
    id: "achat-immo-corporelle",
    cycle: "Achats",
    titre: "Acquisition d'une immobilisation corporelle",
    situation: "Achat d'une machine 12 000 € HT, TVA 20 % (2 400 €), réglée à crédit.",
    lignes: [
      { num: "2154", lib: "Matériel industriel", debit: 12000, credit: 0 },
      { num: "44562", lib: "TVA déductible sur immobilisations", debit: 2400, credit: 0 },
      { num: "404", lib: "Fournisseurs d'immobilisations", debit: 0, credit: 14400 },
    ],
    commentaire:
      "Attention : compte 404 (et non 401) pour les immos. TVA en 44562 (et non 44566). Le coût d'entrée comprend tous les frais d'achat (transport, installation).",
  },

  // ─── VENTES ──────────────────────────────────────────────────────────
  {
    id: "vente-marchandises-tva20",
    cycle: "Ventes",
    titre: "Vente de marchandises avec TVA 20 %",
    situation: "Vente de marchandises pour 2 000 € HT, TVA 20 %, à crédit.",
    lignes: [
      { num: "411", lib: "Clients", debit: 2400, credit: 0 },
      { num: "707", lib: "Ventes de marchandises", debit: 0, credit: 2000 },
      { num: "44571", lib: "TVA collectée", debit: 0, credit: 400 },
    ],
    commentaire:
      "Le client doit le TTC (créance en 411). La vente HT alimente le chiffre d'affaires (707). La TVA collectée est une dette envers l'État.",
  },
  {
    id: "vente-prestation-service",
    cycle: "Ventes",
    titre: "Vente d'une prestation de service",
    situation: "Facture d'une prestation de conseil 5 000 € HT, TVA 20 % (1 000 €).",
    lignes: [
      { num: "411", lib: "Clients", debit: 6000, credit: 0 },
      { num: "706", lib: "Prestations de services", debit: 0, credit: 5000 },
      { num: "44571", lib: "TVA collectée", debit: 0, credit: 1000 },
    ],
    commentaire:
      "Pour une prestation, on utilise le compte 706 (et non 707 qui est réservé aux ventes de marchandises).",
  },
  {
    id: "avoir-client",
    cycle: "Ventes",
    titre: "Avoir émis à un client",
    situation: "Avoir de 600 € TTC accordé à un client (500 HT + 100 TVA) pour qualité défectueuse.",
    lignes: [
      { num: "709", lib: "RRR accordés", debit: 500, credit: 0 },
      { num: "44571", lib: "TVA collectée", debit: 100, credit: 0 },
      { num: "411", lib: "Clients", debit: 0, credit: 600 },
    ],
    commentaire:
      "On contrepasse la créance client. 709 est débité car il vient en diminution du CA (sens débiteur pour un compte qui réduit un compte créditeur).",
  },
  {
    id: "vente-export-ue",
    cycle: "Ventes",
    titre: "Vente intra-UE (livraison exonérée)",
    situation: "Livraison de marchandises à un client allemand assujetti, 3 000 € HT (autoliquidation côté client).",
    lignes: [
      { num: "411", lib: "Clients", debit: 3000, credit: 0 },
      { num: "707", lib: "Ventes de marchandises (livraisons intra-UE)", debit: 0, credit: 3000 },
    ],
    commentaire:
      "Pas de TVA française : c'est l'acquéreur qui autoliquide la TVA dans son pays. Mention obligatoire « Exonération TVA, art. 262 ter I du CGI » sur la facture.",
  },

  // ─── TRÉSORERIE ──────────────────────────────────────────────────────
  {
    id: "reglement-client-banque",
    cycle: "Trésorerie",
    titre: "Encaissement d'un règlement client (virement)",
    situation: "Le client paie 2 400 € par virement bancaire.",
    lignes: [
      { num: "512", lib: "Banque", debit: 2400, credit: 0 },
      { num: "411", lib: "Clients", debit: 0, credit: 2400 },
    ],
    commentaire:
      "La trésorerie augmente (banque débitée), la créance client diminue (411 crédité). À lettrer ensuite avec la facture d'origine.",
  },
  {
    id: "paiement-fournisseur",
    cycle: "Trésorerie",
    titre: "Règlement d'un fournisseur",
    situation: "Paiement par virement d'une facture fournisseur de 1 200 € TTC.",
    lignes: [
      { num: "401", lib: "Fournisseurs", debit: 1200, credit: 0 },
      { num: "512", lib: "Banque", debit: 0, credit: 1200 },
    ],
    commentaire:
      "La dette diminue (401 débité), la trésorerie diminue (512 créditée). Lettrer ensuite contre la facture d'origine.",
  },
  {
    id: "agios-bancaires",
    cycle: "Trésorerie",
    titre: "Agios et frais bancaires",
    situation: "Prélèvement bancaire de 45 € de frais et 12 € d'agios sur l'extrait.",
    lignes: [
      { num: "627", lib: "Services bancaires", debit: 45, credit: 0 },
      { num: "6615", lib: "Intérêts des emprunts et dettes (agios)", debit: 12, credit: 0 },
      { num: "512", lib: "Banque", debit: 0, credit: 57 },
    ],
    commentaire:
      "On distingue les frais (627, charge d'exploitation) des agios (6615, charge financière). Pas de TVA sur les services bancaires (exonérés).",
  },

  // ─── PAIE & PERSONNEL ────────────────────────────────────────────────
  {
    id: "paie-salaires",
    cycle: "Paie",
    titre: "Comptabilisation des salaires bruts",
    situation: "Salaires bruts du mois : 20 000 €. Cotisations salariales : 4 000 €. Net à payer : 16 000 €.",
    lignes: [
      { num: "641", lib: "Rémunérations du personnel", debit: 20000, credit: 0 },
      { num: "421", lib: "Personnel - rémunérations dues", debit: 0, credit: 16000 },
      { num: "431", lib: "Sécurité sociale (part salariale)", debit: 0, credit: 4000 },
    ],
    commentaire:
      "Le brut alimente la charge (641). On éclate la dette : ce qui reste dû aux salariés (421) et ce qui sera reversé aux organismes (431, 437…).",
  },
  {
    id: "charges-patronales",
    cycle: "Paie",
    titre: "Charges patronales",
    situation: "Cotisations patronales calculées sur le brut : 8 500 €.",
    lignes: [
      { num: "645", lib: "Charges de sécurité sociale et de prévoyance", debit: 8500, credit: 0 },
      { num: "431", lib: "Sécurité sociale (part patronale)", debit: 0, credit: 8500 },
    ],
    commentaire:
      "Charge supplémentaire pour l'employeur (645). À reverser à l'URSSAF (431). Souvent ventilée entre 4311 (URSSAF) et 437x (autres organismes).",
  },
  {
    id: "reglement-paie",
    cycle: "Paie",
    titre: "Paiement des salaires nets",
    situation: "Virement des salaires nets 16 000 € aux salariés.",
    lignes: [
      { num: "421", lib: "Personnel - rémunérations dues", debit: 16000, credit: 0 },
      { num: "512", lib: "Banque", debit: 0, credit: 16000 },
    ],
    commentaire: "Solde la dette envers les salariés et diminue la trésorerie.",
  },

  // ─── TVA ─────────────────────────────────────────────────────────────
  {
    id: "declaration-tva",
    cycle: "TVA",
    titre: "Déclaration de TVA mensuelle",
    situation: "TVA collectée du mois : 5 000 €. TVA déductible : 3 200 €. TVA à décaisser : 1 800 €.",
    lignes: [
      { num: "44571", lib: "TVA collectée", debit: 5000, credit: 0 },
      { num: "44566", lib: "TVA déductible sur ABS", debit: 0, credit: 3000 },
      { num: "44562", lib: "TVA déductible sur immobilisations", debit: 0, credit: 200 },
      { num: "44551", lib: "TVA à décaisser", debit: 0, credit: 1800 },
    ],
    commentaire:
      "On solde les comptes de TVA du mois. Le reliquat (44551) est la dette nette envers l'État, à régler le mois suivant.",
    variantes: ["Crédit de TVA : si déductible > collectée, solde au débit du 44567 (crédit de TVA)"],
  },
  {
    id: "paiement-tva",
    cycle: "TVA",
    titre: "Paiement de la TVA à l'État",
    situation: "Règlement de la TVA à décaisser : 1 800 €.",
    lignes: [
      { num: "44551", lib: "TVA à décaisser", debit: 1800, credit: 0 },
      { num: "512", lib: "Banque", debit: 0, credit: 1800 },
    ],
    commentaire: "Solde la dette de TVA envers l'État.",
  },
  {
    id: "autoliquidation-tva",
    cycle: "TVA",
    titre: "Autoliquidation de TVA (achat intra-UE)",
    situation: "Achat de marchandises auprès d'un fournisseur espagnol : 4 000 € HT (pas de TVA sur la facture).",
    lignes: [
      { num: "607", lib: "Achats de marchandises", debit: 4000, credit: 0 },
      { num: "44566", lib: "TVA déductible sur ABS", debit: 800, credit: 0 },
      { num: "401", lib: "Fournisseurs", debit: 0, credit: 4000 },
      { num: "4452", lib: "TVA due intracommunautaire", debit: 0, credit: 800 },
    ],
    commentaire:
      "L'acheteur autoliquide : il enregistre la TVA simultanément en déductible (44566) et en collectée (4452). Effet neutre en trésorerie, contrôle déclaratif.",
  },

  // ─── IMMOBILISATIONS ─────────────────────────────────────────────────
  {
    id: "amortissement-lineaire",
    cycle: "Immobilisations",
    titre: "Dotation aux amortissements (linéaire)",
    situation: "Machine 12 000 €, amortie sur 5 ans → dotation annuelle 2 400 €.",
    lignes: [
      { num: "68112", lib: "Dotations aux amortissements des immo. corporelles", debit: 2400, credit: 0 },
      { num: "28154", lib: "Amortissements du matériel industriel", debit: 0, credit: 2400 },
    ],
    commentaire:
      "Le 28x miroir du 21x. La VNC (Valeur Nette Comptable) au bilan = 21x − 28x. Charge calculée, sans flux de trésorerie.",
  },
  {
    id: "cession-immo",
    cycle: "Immobilisations",
    titre: "Cession d'une immobilisation",
    situation: "Vente d'une machine : prix de cession 4 000 € HT, VNC 3 000 € (10 000 − 7 000 d'amortissements cumulés).",
    lignes: [
      { num: "462", lib: "Créances sur cessions d'immobilisations", debit: 4800, credit: 0 },
      { num: "757", lib: "Produits des cessions d'éléments d'actif", debit: 0, credit: 4000 },
      { num: "44571", lib: "TVA collectée", debit: 0, credit: 800 },
      { num: "28154", lib: "Amortissements", debit: 7000, credit: 0 },
      { num: "657", lib: "VCEAC", debit: 3000, credit: 0 },
      { num: "2154", lib: "Matériel industriel", debit: 0, credit: 10000 },
    ],
    commentaire:
      "Double écriture : (1) constatation du prix de vente avec TVA et créance, (2) sortie du bilan : on solde l'amortissement et la valeur brute, la VNC va en charge exceptionnelle (657). Plus-value = 757 − 657 = 1 000 €.",
  },

  // ─── OPÉRATIONS DE CLÔTURE ──────────────────────────────────────────
  {
    id: "fnp-charges",
    cycle: "Clôture",
    titre: "Facture non parvenue (FNP)",
    situation: "Au 31/12, une marchandise reçue 800 € HT n'a pas encore donné lieu à facture du fournisseur.",
    lignes: [
      { num: "607", lib: "Achats de marchandises", debit: 800, credit: 0 },
      { num: "44586", lib: "TVA sur factures non parvenues", debit: 160, credit: 0 },
      { num: "408", lib: "Fournisseurs - factures non parvenues", debit: 0, credit: 960 },
    ],
    commentaire:
      "Principe de séparation des exercices : la charge appartient à l'année N même sans facture. Écriture contre-passée à l'ouverture de N+1.",
  },
  {
    id: "fae-produits",
    cycle: "Clôture",
    titre: "Facture à établir (FAE)",
    situation: "Prestation livrée en décembre, non encore facturée : 1 500 € HT.",
    lignes: [
      { num: "418", lib: "Clients - produits non encore facturés", debit: 1800, credit: 0 },
      { num: "706", lib: "Prestations de services", debit: 0, credit: 1500 },
      { num: "44587", lib: "TVA sur factures à établir", debit: 0, credit: 300 },
    ],
    commentaire:
      "Le produit est acquis à l'exercice N. La facture sera émise en N+1, où on contre-passera et on enregistrera la vraie facture.",
  },
  {
    id: "cca",
    cycle: "Clôture",
    titre: "Charge constatée d'avance (CCA)",
    situation: "Loyer 6 000 € payé pour la période janv-juin N+1 (à régulariser au 31/12/N).",
    lignes: [
      { num: "486", lib: "Charges constatées d'avance", debit: 6000, credit: 0 },
      { num: "613", lib: "Locations", debit: 0, credit: 6000 },
    ],
    commentaire:
      "La charge appartient à N+1, pas à N. On la sort temporairement de l'exercice N en créditant 613 et en débitant 486 (actif circulant).",
  },
  {
    id: "pca",
    cycle: "Clôture",
    titre: "Produit constaté d'avance (PCA)",
    situation: "Abonnement encaissé d'avance 1 200 € HT pour 6 mois (jan-juin N+1).",
    lignes: [
      { num: "706", lib: "Prestations de services", debit: 1200, credit: 0 },
      { num: "487", lib: "Produits constatés d'avance", debit: 0, credit: 1200 },
    ],
    commentaire:
      "Le produit n'est pas acquis à N. On le décale en passif transitoire (487). Sera repris en produit en N+1 au prorata des mois courus.",
  },
  {
    id: "depreciation-client",
    cycle: "Clôture",
    titre: "Dépréciation d'un client douteux",
    situation: "Créance client 1 200 € TTC (1 000 HT) probablement irrécouvrable à 60 %.",
    lignes: [
      { num: "416", lib: "Clients douteux ou litigieux", debit: 1200, credit: 0 },
      { num: "411", lib: "Clients", debit: 0, credit: 1200 },
      { num: "68174", lib: "Dotations dépréciations créances", debit: 600, credit: 0 },
      { num: "491", lib: "Dépréciations comptes clients", debit: 0, credit: 600 },
    ],
    commentaire:
      "Deux écritures : (1) reclasse en 416 (suivi spécifique), (2) constate la dépréciation à hauteur du risque sur le HT. Si la créance devient totalement irrécouvrable : 654 (perte sur créance) au lieu de la dépréciation.",
  },
  {
    id: "creance-irrecouvrable",
    cycle: "Clôture",
    titre: "Créance définitivement irrécouvrable",
    situation: "Le client est en liquidation. Créance 1 200 € TTC perdue (dépréciation 600 € constituée).",
    lignes: [
      { num: "654", lib: "Pertes sur créances irrécouvrables", debit: 1000, credit: 0 },
      { num: "44571", lib: "TVA collectée (régularisation)", debit: 200, credit: 0 },
      { num: "416", lib: "Clients douteux", debit: 0, credit: 1200 },
      { num: "491", lib: "Dépréciations clients", debit: 600, credit: 0 },
      { num: "78174", lib: "Reprises sur dépréciations", debit: 0, credit: 600 },
    ],
    commentaire:
      "La perte définitive permet de récupérer la TVA collectée (justificatif : irrécouvrabilité prouvée). On contre-passe aussi la dépréciation devenue sans objet.",
  },
];

// Index par cycle pour la navigation
export const CYCLES = [
  { id: "Achats", color: "#B85724", icon: "shopping-cart" },
  { id: "Ventes", color: "#2F7A5C", icon: "tag" },
  { id: "Trésorerie", color: "#2D6BE0", icon: "wallet" },
  { id: "Paie", color: "#A33B4B", icon: "users" },
  { id: "TVA", color: "#A56A2E", icon: "receipt" },
  { id: "Immobilisations", color: "#3B1E6E", icon: "building" },
  { id: "Clôture", color: "#474D59", icon: "calendar-check" },
];

export const TOTAL_TVA = (lignes) => {
  return lignes.reduce(
    (acc, l) => ({
      debit: acc.debit + (l.debit || 0),
      credit: acc.credit + (l.credit || 0),
    }),
    { debit: 0, credit: 0 }
  );
};
